import { SUPPLIER_LAYOUTS, SUPPLIER_NAV_KEYS, SUPPLIER_PATHS, SUPPLIER_ROUTE_NAMES } from './routeNames'

const title = (key) => `ui.supplier_portal.titles.${key}`

const SupplierProductFormPage = () => import('@supplier/pages/product-form/SupplierProductFormPage.vue')

export const routes = [
  {
    path: '/',
    redirect: { name: SUPPLIER_ROUTE_NAMES.PRODUCTS },
  },
  {
    path: SUPPLIER_PATHS.DASHBOARD,
    name: SUPPLIER_ROUTE_NAMES.DASHBOARD,
    component: () => import('@supplier/pages/dashboard/SupplierDashboardPage.vue'),
    meta: { title: title('dashboard'), navKey: SUPPLIER_NAV_KEYS.DASHBOARD },
  },
  {
    path: SUPPLIER_PATHS.PROFILE,
    name: SUPPLIER_ROUTE_NAMES.PROFILE,
    component: () => import('@supplier/pages/profile/SupplierProfilePage.vue'),
    meta: { title: title('profile') },
  },
  {
    path: SUPPLIER_PATHS.ORDERS,
    name: SUPPLIER_ROUTE_NAMES.ORDERS,
    component: () => import('@supplier/pages/orders/SupplierOrdersPage.vue'),
    meta: { title: title('orders'), navKey: SUPPLIER_NAV_KEYS.ORDERS },
  },
  {
    path: '/orders/:userid/:storeid?',
    redirect: (to) => ({ name: SUPPLIER_ROUTE_NAMES.ORDERS, query: to.query }),
  },
  {
    path: SUPPLIER_PATHS.PAYOUTS,
    name: SUPPLIER_ROUTE_NAMES.PAYOUTS,
    component: () => import('@supplier/pages/payouts/SupplierPayoutsPage.vue'),
    meta: { title: title('payouts'), navKey: SUPPLIER_NAV_KEYS.PAYOUTS },
  },
  {
    path: SUPPLIER_PATHS.PRODUCTS,
    name: SUPPLIER_ROUTE_NAMES.PRODUCTS,
    component: () => import('@supplier/pages/products/SupplierProductsPage.vue'),
    meta: { title: title('products'), navKey: SUPPLIER_NAV_KEYS.PRODUCTS },
  },
  {
    path: SUPPLIER_PATHS.PRODUCT_ADD,
    name: SUPPLIER_ROUTE_NAMES.PRODUCT_ADD,
    component: SupplierProductFormPage,
    props: { mode: 'add', productId: null },
    meta: { title: title('add_product'), navKey: SUPPLIER_NAV_KEYS.PRODUCTS },
  },
  {
    path: '/product/edit/:id(\\d+)',
    name: SUPPLIER_ROUTE_NAMES.PRODUCT_EDIT,
    component: SupplierProductFormPage,
    props: (route) => ({ mode: 'edit', productId: Number(route.params.id) }),
    meta: { title: title('edit_product'), navKey: SUPPLIER_NAV_KEYS.PRODUCTS },
  },
  {
    path: '/product/:id(\\d+)/:slug',
    redirect: (to) => ({ name: SUPPLIER_ROUTE_NAMES.PRODUCT_EDIT, params: { id: to.params.id } }),
  },
  {
    path: '/product-import-options',
    redirect: { name: SUPPLIER_ROUTE_NAMES.PRODUCTS },
  },
  {
    path: SUPPLIER_PATHS.REVIEW_PRODUCTS,
    name: SUPPLIER_ROUTE_NAMES.REVIEW_PRODUCTS,
    component: () => import('@supplier/pages/review-products/SupplierReviewProductsPage.vue'),
    meta: { title: title('review_products'), layout: SUPPLIER_LAYOUTS.BLANK },
  },
  {
    path: '/:pathMatch(.*)*',
    name: SUPPLIER_ROUTE_NAMES.NOT_FOUND,
    component: () => import('@/pages/errors/NotFoundPage.vue'),
    meta: { title: title('not_found'), layout: SUPPLIER_LAYOUTS.BLANK },
  },
]
